import React, {Component, PropTypes} from 'react';
import {
  get,
  isEmpty,
  isNil,
  isNaN,
  merge, map
} from 'lodash';
import TextField from '../../../../../../common/components/c_TextField';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import cx from 'classnames';

export default class JobRequestWorksheetBilling extends Component {

  static propTypes = {
    handleSave    : PropTypes.func.isRequired,
    jobRequest    : PropTypes.object.isRequired,
    primaryContact: PropTypes.object.isRequired,
    staticData    : PropTypes.object.isRequired,
    labels        : PropTypes.object,
    disabled      : PropTypes.bool
  };

  constructor(props) {
    super(props);

    const markUp = this.props.jobRequest.markUp ||
      (this.props.jobRequest.billRate && this.props.jobRequest.payRate) ?
      (this.props.jobRequest.billRate / this.props.jobRequest.payRate).toFixed(2) : '0';

    this.state = {
      dirty: false,
      billing: {
        placementFee: this.props.primaryContact.company.placementFee,
        salesPartner: this.props.primaryContact.company.salesPartner,
        fee: 0,
        commission: this.props.jobRequest.commission,
        payRate: this.maskCurrency(this.props.jobRequest.payRate),
        billRate: this.maskCurrency(this.props.jobRequest.billRate),
        markUp,
      },
      menuItems: {
        placementFee: map(this.props.staticData.setupFees,
          item => {
            return {
              primaryText: item.name === '$0' ? 'Waived' : item.name,
              value: this.currencyToNumber(item.name)
            };
          }),
        commission: map(this.props.staticData.commission, ({value}) => ({primaryText: `${(value * 100)}%`, value}))
      }
    };

    this.handleDropdown = ::this.handleDropdown;
    this.handleTextField = ::this.handleTextField;

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.jobRequests) {
      this.setState(merge({}, this.state, {jobRequest: nextProps.jobRequest}));
    }
  }

  maskCurrency(currency, precision = 2) {

    const currencyString = String(currency);
    const lastDigit = currencyString[currencyString.length - 1];
    const beforeLastDigit = currencyString[currencyString.length - 2];
    if(lastDigit === '.') {
        return currency;
    }

    if(lastDigit === '0' && beforeLastDigit !== '0') {
        return currency;
    }

    const currencyNumber = Number(currencyString.replace(/[^0-9\.]+/g, ''));

    return currencyNumber.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: precision
    });

  }

  currencyToNumber (currency) {
    const currencyString = String(currency);
    return Number(currencyString.replace(/[^0-9\.]+/g, ''));
  }

  handleChange(prop) {

    return (event, value) => {

      const billing = merge({}, this.state.billing);
      billing[prop] = value;
      const markup = (this.currencyToNumber(billing.billRate) / this.currencyToNumber(billing.payRate));
      billing.markUp = isNaN(markup) ? 0 : markup.toFixed(2);
      billing.payRate = this.maskCurrency(billing.payRate);
      billing.billRate = this.maskCurrency(billing.billRate);
      billing.fee = this.maskCurrency(billing.fee);


      this.setState({billing, dirty: true});

    };
  }

  handleDropdown(prop, label, menuItems) {

    return {
      'data-id': prop,
      value: this.state.billing[prop],
      onChange: this.handleChange(prop),
      floatingLabelText: label,
      menuItems,
      disabled: this.props.disabled,
    };
  }

  handleTextField(prop, label) {

    return {
      'data-id': prop,
      value: this.state.billing[prop],
      onChange: this.handleChange(prop),
      floatingLabelText: label,
      disabled: this.props.disabled,
    };
  }

  handlePercentageChange(prop, min, max) {
    const handleChange = this.handleChange(prop);
    return (event, value) => {
      const number = isEmpty(value) ? 0 : parseInt(value, 10);
      if (isNil(value) || (!isNaN(number) && number >= min && number <= max)) {
        handleChange(event, number);
      }
    };
  }

  handleSave = () => {

    if(this.state.dirty === false) {
      return;
    }

    this
      .props
      .handleSave({
        company: {
          id: this.props.primaryContact.company.id,
        },
        jobrequest: {
          id: this.props.jobRequest.id,
          primaryContactId: this.props.jobRequest.primaryContactId,
          payRate: this.currencyToNumber(this.state.billing.payRate),
          billRate: this.currencyToNumber(this.state.billing.billRate),
          markUp: this.state.billing.markUp,
          commission: this.state.billing.commission,
          fee: this.currencyToNumber(this.state.billing.fee)
        }
      }).then(() => {
        this.setState({dirty: false });
      });

  }

  renderSetupFee(state, props) {

    const ACTIVE_ACCOUNT = 4;
    const status = get(props, 'primaryContact.company.companyStatus');
    const setupFee = get(props, 'labels.oneTimeSetupFee', true);

    if (setupFee && ![ACTIVE_ACCOUNT].includes(status)) {
      return(
        <DropDownMenu {...this.handleDropdown('placementFee', 'One Time Setup Fee', state.menuItems.placementFee)} disabled />
      );
    }

  }

  render() {
    const {state} = this;

    return (
      <div className='job-request-worksheet-billing'>
        <h1 className='heading'>Billing</h1>
        <div className='grid'>
          <div className='row'>
            <div className='col'>
               <div className='row'>
                 <div className='col'><TextField {...this.handleTextField('payRate', 'Pay Rate')}/></div>
                 <div className='col'><TextField {...this.handleTextField('billRate', 'Bill Rate')}/></div>
               </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='col'>
                  <TextField {...this.handleTextField('markUp', 'Mark Up %')} onChange={this.handlePercentageChange('markUp', 0, 100)}/>
                </div>
                <div className='col'>
                {
                  this.renderSetupFee(state, this.props)
                }
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <div className='row'>
                <div className='col  grow-2'>
                  <DropDownMenu
                    {...this.handleDropdown('salesPartner', 'Sales Partner', this.props.staticData.salesPartners)}
                    disabled
                  />
                </div>
                <div className='col'> <DropDownMenu  className='commission-textfield' {...this.handleDropdown('commission', 'Commission', state.menuItems.commission)} /> </div>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='col grow-2'><DropDownMenu className='referrer-dropdown' {...this.handleDropdown('referrer', 'Referrer', [])} /></div>
                <div className='col'>
                  <TextField  className='fee-textfield' {...this.handleTextField('fee', 'Referrer Fee')} />
                </div>
              </div>
            </div>
          </div>
          {this.props.disabled ? null :  <div className='row'>
            <div className='col'>
              <FlatButton
                className={cx('button-save', {disabled: !this.state.dirty})}
                onClick={this.handleSave}
                data-id='save'
                label='save'/>
            </div>
          </div>}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Profile/Billing/index.js